import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { SalesForceChatProvider } from 'Douleutaras/providers/chat/SalesForceChat.provider';
import { getDefaultLanguageCodeByCountryCode, useLocalization } from 'Douleutaras/hooks/localization';
import { selectCurrentUser } from 'Douleutaras/redux/data/auth/authSlice';

let SINGLETON_INSTANCE: SalesForceChatProvider | (() => SalesForceChatProvider);
let LOADED = false;

/**
 * This hook will create a new SalesForceChatProvider provider instance.
 */
export const useSalesForceChat = (): SalesForceChatProvider => {
  const { siteId } = useLocalization();
  const defaultLang = getDefaultLanguageCodeByCountryCode();
  const { t } = useTranslation();
  const user = useAppSelector(selectCurrentUser);
  const ff = useAppSelector(state => state.featureFlags);
  // tslint:disable-next-line:no-null-keyword
  const [provider, setProvider] = useState<SalesForceChatProvider | undefined>(SINGLETON_INSTANCE);

  useEffect(() => {
    if (Boolean(provider) || !ff.loaded || LOADED || ff.entities.useSalesforceChat === false) {
      return;
    }

    LOADED = true;

    const P = ff.entities.useSalesforceChatNew ? 'SalesForceChatV2' : 'SalesForceChat';

    import(`Douleutaras/providers/chat/${P}.provider`)
      .then(all => {
        const instance = all[`${P}Provider`].getInstance(t, defaultLang, siteId, user);
        setProvider(instance);
        SINGLETON_INSTANCE = instance;
      });
  }, [ff.loaded]);

  return provider;
};
